<template lang="pug">
.info-circle(
  @click="openInfoModalForMobile"
  :class="{'info-circle_img': infoImage || narrowIcon}"
)
  BTooltip.info-circle__tooltip.info-circle__tooltip_html(
    v-if="html"

    always
    :active="active"
    :animated="animated"
    :position="position"
    :multilined="multilined"
  )
    .info-circle__wrap(
      :class="{'info-circle__wrap_img': narrowIcon}"
      @mouseover="active=true"
      @mouseleave="setHoverTimeout"
    )
      i.rss-icon-info-solid(
        v-if="!narrowIcon"
      )
      InfoIcon(
        v-else
      )

    .info-circle__html-content(
      slot="content"
      ref="tooltipHtmlContent"
    )
      p(
        v-html="text"
      )

  BTooltip.info-circle__tooltip(
    :label="text"
    v-if="!infoImage && !html"
    :multilined="multilined"
    :animated="animated"
    :position="position"
  )
    template(
      v-if="html"
      slot="content"
    )
      p(
        v-html="text"
      )
    .info-circle__wrap(
      v-if="!customIcon"
    )
      i.rss-icon-info-solid

  .info-circle__wrap.info-circle__wrap_img(
    v-if="infoImage && !customIcon && !html"
  )
    InfoIcon
    .info-circle__content
      img(
        :src="infoImage"
      )
</template>

<script>
import { mapActions } from 'vuex'

import InfoIcon from './svg/InfoIcon.vue'

export default {
  components: {
    InfoIcon
  },

  props: {
    text: {
      type: String,
      default: ''
    },
    multilined: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 20
    },
    position: {
      type: String,
      default: 'is-top'
    },
    infoImage: {
      type: String,
      default: ''
    },
    html: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: true
    },
    narrowIcon: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      active: false,
      hoverTimeout: null,
      modalIsActive: false
    }
  },

  mounted () {
    if (this.html) {
      const tooltipHtmlContentEl = this.$refs.tooltipHtmlContent
      if (tooltipHtmlContentEl && tooltipHtmlContentEl.parentElement) {
        const tooltipContentEl = tooltipHtmlContentEl.parentElement
        tooltipContentEl.addEventListener('mouseenter', () => {
          this.removeHoverTimeout()
          this.active = true
        })
        tooltipContentEl.addEventListener('mouseleave', () => {
          this.active = false
        })
      }
    }
  },

  methods: {
    ...mapActions('coachmarks', ['setInfoForMobileModal']),

    setHoverTimeout () {
      this.hoverTimeout = setTimeout(() => {
        this.active = false
      }, 300)
    },

    removeHoverTimeout () {
      clearTimeout(this.hoverTimeout)
    },

    openInfoModalForMobile () {
      // es-lint-disable-next-line
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (windowWidth < 960) {
        this.setInfoForMobileModal(this.text)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-circle {
  margin-top: -2px;
  margin-left: $gap;
  display: inline-block;

  &_img {
    margin-top: 0;
    margin-left: $gap / 2;
  }

  &__tooltip {
    &_html {
      /deep/ .tooltip-content {
        &:after {
          left: 0;
          right: 0;
          content: '';
          height: 10px;
          display: block;
          position: absolute;
        }

        a {
          color: #fff;
        }
      }
    }

    &:after, &:before {
      color: #fff;
    }

    @include display-less(desktop) {
      cursor: pointer;

      &:hover {
        &:after, &:before {
          display: none;
        }
      }
    }
  }

  &__wrap {
    color: #fff;
    width: 20px;
    height: 20px;
    display: flex;
    font-size: 12px;
    border-radius: 16px;
    align-items: center;
    justify-content: center;
    background-color: $colorPrimary;

    &_img {
      width: 16px;
      height: 16px;
      cursor: pointer;
      background-color: transparent;

      &:hover {
        .info-circle__content {
          display: block;
        }
      }
    }
  }

  &__content {
    z-index: 3;
    bottom: 100%;
    display: none;
    padding: 12px 16px;
    position: absolute;
    border-radius: 4px;
    margin-bottom: $gap / 2;
    background-color: #6C26D6;

    &:after {
      width: 0;
      height: 0;
      left: 50%;
      content: '';
      bottom: -4px;
      margin-left: -4px;
      position: absolute;
      border-style: solid;
      border-width: 4px 4px 0 4px;
      border-color: $colorAccent transparent transparent transparent;
    }
  }
}
</style>
